if($('body').hasClass('tender')){

    let proposedStartDate = $('#proposed_start_date').data('prefill');
    $('#proposed_start_date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: proposedStartDate ? moment(proposedStartDate, 'DD/MM/YYYY') : null
    });

    let returnDefault = $('#tender-return-date').data('prefill');
    $('#tender-return-date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: returnDefault ? moment(returnDefault, 'DD/MM/YYYY') : moment()
    });

    let submissionDefault = $('#submission-date').data('prefill');
    $('#submission-date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: submissionDefault ? moment(submissionDefault, 'DD/MM/YYYY') : null
    });

    let enterDefault = $('#enter-date').data('prefill');
    $('#enter-date').datetimepicker({
        format: 'DD/MM/YYYY',
        defaultDate: enterDefault ? moment(enterDefault, 'DD/MM/YYYY') : null
    });

    $('#contact-form #client').val($('#client').val()).parent().hide();
    $('#client').change(function(){
        $('#contact-form #client').val($('#client').val());
    });

    $(document).ready(function(){
        $('.tender.index #client').change(function(){
            $('#contact_filter').empty();
            $('#contact_filter').append("<option value=''>-</option>");
            $.each($(this).find('option:selected').data('contacts'), function (key, value) {
                $('#contact_filter').append('<option value=' + value.id + '>' + value.name + '</option>');
            });
        });
    });
}
